import type { RouteObject } from 'react-router';
import { RacesPage } from './pages/RacesPage';
import { RaceDetailPage } from './pages/RaceDetailPage';

export const raceRoutes: RouteObject[] = [
  { path: 'wager-races', element: <RacesPage /> },
  { path: 'wager-races/:slug', element: <RaceDetailPage /> },
];
